const menuIcons = {
  backofficeLogo: '/images/menu_icon/logo_pdmin_color.svg',
  dfineryLogo: '/images/menu_icon/logo_dfinery_color.png',
  walletActive: '/images/menu_icon/walletActive.svg',
  walletDefault: '/images/menu_icon/walletDefault.svg',
  appActive: '/images/menu_icon/appActive.svg',
  appDefault: '/images/menu_icon/appDefault.svg',
  eventActive: '/images/menu_icon/eventActive.svg',
  eventDefault: '/images/menu_icon/eventDefault.svg',
  userActive: '/images/menu_icon/userActive.svg',
  userDefault: '/images/menu_icon/userDefault.svg',
  monitoringActive: '/images/menu_icon/monitoringActive.svg',
  monitoringDefault: '/images/menu_icon/monitoringDefault.svg',
  backofficeActive: '/images/menu_icon/backofficeActive.svg',
  backofficeDefault: '/images/menu_icon/backofficeDefault.svg',
  settingActive: '/images/menu_icon/settingActive.svg',
  settingDefault: '/images/menu_icon/settingDefault.svg',
  logActive: '/images/menu_icon/logActive.svg',
  logDefault: '/images/menu_icon/logDefault.svg',
  welcomeImage: '/images/menu_icon/welcome.svg',
  defaultIcon: '',
};

export default menuIcons;
